import { DIALOG_IDS, modalStore } from '@core/modal'
import { useActions } from '@core/store'
import { giftStore, type TGiftRecipient } from '../store/giftStore'

/** The gate lives in the caller (`shouldOfferGift`) and the show event in `GiftDialogContainer`. */
export const useGiftDialog = () => {
    const actions = useActions({
        setRecipient: giftStore.actions.setRecipient,
        openModal: modalStore.actions.open,
        closeModal: modalStore.actions.close,
    })

    const open = (recipient: TGiftRecipient) => {
        actions.setRecipient(recipient)
        actions.openModal(DIALOG_IDS.giftSub)
    }

    const close = () => {
        actions.closeModal()
        actions.setRecipient(null)
    }

    return { open, close }
}
